ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
removeById = require 'app/scripts/lib/util/array/remove-by-id'
_ = require 'underscore'
{ Analytics } = require '@trello/atlassian-analytics'
xtend = require 'xtend'

# Mixin for models that have memberships
MembershipModel =
  orderedVisibleAdmins: ->
    @adminList
    .sortBy (member) =>
      prefix =
        if Auth.isMe(member)
          # The current user is always first in the list
          '0'
        else if @isDeactivated(member)
          # Deactivated users always come last
          '4'
        else if @isVirtual(member)
          '3'
        else if @getMemberType(member) == 'admin'
          # Admins toward the front
          '1'
        else
          '2'

      prefix + member.get('fullName')?.toLocaleLowerCase()
    .filter (member) =>
      (!@isDeactivated(member) || @canSeeDeactivated(Auth.me()))

  orderedVisibleMembers: ->
    @memberList
    .sortBy (member) =>
      prefix =
        if Auth.isMe(member)
          # The current user is always first in the list
          '0'
        else if @isDeactivated(member)
          # Deactivated users always come last
          '4'
        else if @isVirtual(member)
          '3'
        else if @getMemberType(member) == 'admin'
          # Admins toward the front
          '1'
        else
          '2'

      prefix + member.get('fullName')?.toLocaleLowerCase()
    .filter (member) =>
      (!@isDeactivated(member) || @canSeeDeactivated(Auth.me()))

  getMemberType: (member, opts = {}) ->
    { ignoreEntAdminStatus } = opts
    if !ignoreEntAdminStatus && @getEnterprise?()?.isAdmin(member)
      memberType = 'admin'
    else if @getOrganization?()?.isPremOrgAdmin(member)
      memberType = 'admin'
    else
      memberType = @getExplicitMemberType(member)

    if memberType != 'public' && @isVirtual?(member)
      memberType = 'virtual'

    memberType

  _refreshMemberships: ->
    @_memberships.update(@get('memberships'))

  _getMembershipFor: (member) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    MembershipList = require 'app/scripts/models/collections/membership-list'

    if !@_memberships
      @_memberships = new MembershipList()
      @_refreshMemberships()

      @listenTo(@, 'change:memberships', @_refreshMemberships)

    @_memberships.getMember(member)

  getMembershipFor: (member) ->
    # Much of the underlying code expects a basic object, and not a model. This
    # is something we can change in the future by moving more methods on to the
    # membership model.
    @_getMembershipFor(member)?.toJSON()

  hasActiveMembership: (member) ->
    @_getMembershipFor(member)? && !@isDeactivated(member)

  isMember: (member) -> @getMemberType(member) in ['virtual', 'normal', 'admin']

  isVirtual: (member) -> member?.get('memberType') == 'ghost'

  isDeactivated: (member) ->
    @_getMembershipFor(member)?.get('deactivated') == true

  isUnconfirmed: (member) ->
    @_getMembershipFor(member)?.get('unconfirmed') == true

  isObserver: (member) ->
    @getExplicitMemberType(member) == 'observer'

  isPremOrgAdmin: (memberOrId) ->
    # 'memberOrId' can be a member or just an id here, hence the extra checks
    # This is true for many of the methods in this file. Presumably this
    # is so we can handle deleted members properly. Item to clean
    # this up on card https://trello.com/c/jB0cQJPR

    if _.isString(memberOrId)
      memberOrId = @modelCache.get('Member', memberOrId)

    idPremOrgsAdmin = memberOrId?.get?('idPremOrgsAdmin') ? []

    idOrganization = if @getOrganization
      @getOrganization()?.id
    else
      @id

    return idOrganization in idPremOrgsAdmin

  getExplicitMemberType: (member) ->
    if @isDeactivated(member)
      return 'deactivated'
    else if @isUnconfirmed(member)
      return 'unconfirmed'
    else if (membership = @_getMembershipFor(member))
      return membership.get('memberType')
    else if @getOrganization?()?.isMember(member)
      return 'org'
    else
      return 'public'

  canSeeDeactivated: (member) ->
    @isMember(member) || member.organizationList?.get(@getOrganization()?.id)

  addMembership: (membership) ->
    newMemberships = if @get('memberships')?
        _.clone(@get('memberships'))
      else
        []
    newMemberships.push(membership)
    @set('memberships', newMemberships)

  _removeFromMembershipsAttribute: (membership) ->
    return unless @get('memberships')

    @set('memberships', removeById(@get('memberships'), membership))

  removeMembership: (membership) ->
    @_memberships.remove(membership)
    @_removeFromMembershipsAttribute(membership)

  setOnMembership: (member, attrs) ->
    @set 'memberships': @get('memberships').map (membership) ->
      if membership.idMember == member.id
        xtend membership, attrs
      else
        membership

  toggleMemberHidden: (member, opts) ->
    ApiPromise
      url: "/1/#{@typeName.toLowerCase()}/#{@id}/hiddenGoogleAppsMembers"
      type: opts.type
      data:
        gMail: member.get('gMail')

  addMemberRole: (opts) ->
    ApiPromise
      type: 'PUT'
      url: "/1/#{@typeName.toLowerCase()}/#{@id}/members"
      data: opts
    .then ->
      Analytics.sendTrackEvent({
        action: 'added',
        actionSubject: 'member',
        source: 'inviteToBoardInlineDialog',
        attributes: {
          role: opts.type,
        },
        containers: {
          organization: {
            id: @id
          }
        }
      })

module.exports = MembershipModel
